export const ACCOUNT_TYPES = {
  MASTER: 'normal',
  SUBACCOUNT: 'operator',
};

export const STORAGE_KEYS = {
  USER: 'user',
  HAS_LOGGED_IN: 'hasLoggedIn',
};
